var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lead-form" },
    [
      _c("my-input", {
        ref: "leads_first_name",
        attrs: { name: "first_name", label: _vm.trans("labels.first_name") },
        model: {
          value: _vm.form.first_name,
          callback: function($$v) {
            _vm.$set(_vm.form, "first_name", $$v)
          },
          expression: "form.first_name"
        }
      }),
      _vm._v(" "),
      _c("error-span", { attrs: { error: _vm.form.errors.get("first_name") } }),
      _vm._v(" "),
      _c("my-input", {
        attrs: { name: "last_name", label: _vm.trans("labels.last_name") },
        model: {
          value: _vm.form.last_name,
          callback: function($$v) {
            _vm.$set(_vm.form, "last_name", $$v)
          },
          expression: "form.last_name"
        }
      }),
      _vm._v(" "),
      _c("error-span", { attrs: { error: _vm.form.errors.get("last_name") } }),
      _vm._v(" "),
      _c("my-input", {
        attrs: {
          name: "email",
          type: "email",
          label: _vm.trans("labels.email")
        },
        model: {
          value: _vm.form.email,
          callback: function($$v) {
            _vm.$set(_vm.form, "email", $$v)
          },
          expression: "form.email"
        }
      }),
      _vm._v(" "),
      _c("error-span", { attrs: { error: _vm.form.errors.get("email") } }),
      _vm._v(" "),
      _c("my-input", {
        attrs: {
          name: "phone",
          type: "phone",
          label: _vm.trans("labels.phone")
        },
        model: {
          value: _vm.form.phone,
          callback: function($$v) {
            _vm.$set(_vm.form, "phone", $$v)
          },
          expression: "form.phone"
        }
      }),
      _vm._v(" "),
      _c("error-span", { attrs: { error: _vm.form.errors.get("phone") } }),
      _vm._v(" "),
      _c("my-textarea", {
        attrs: { name: "message", label: _vm.trans("labels.message") },
        model: {
          value: _vm.form.message,
          callback: function($$v) {
            _vm.$set(_vm.form, "message", $$v)
          },
          expression: "form.message"
        }
      }),
      _vm._v(" "),
      _c("error-span", { attrs: { error: _vm.form.errors.get("message") } }),
      _vm._v(" "),
      _vm.$root.country != "it"
        ? [
            _c("div", {
              staticClass: "privacy-policy",
              domProps: {
                innerHTML: _vm._s(
                  _vm.trans("agreements.privacy.label", {
                    link: _vm.trans("agreements.privacy.link")
                  })
                )
              }
            }),
            _vm._v(" "),
            _vm.$root.country != "it"
              ? _c("marketing-checkbox", {
                  attrs: { id: "lead-marketing-checkbox", lang: _vm.lang },
                  model: {
                    value: _vm.form.marketing,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "marketing", $$v)
                    },
                    expression: "form.marketing"
                  }
                })
              : _vm._e()
          ]
        : [
            _c("privacy-checkbox", {
              attrs: {
                name: "privacy",
                id: "lead-privacy-checkbox",
                textPrivacy: _vm.lang.agreements.privacy.label,
                langPrivacy: _vm.langPrivacy,
                modal: "privacy"
              },
              model: {
                value: _vm.form.privacy,
                callback: function($$v) {
                  _vm.$set(_vm.form, "privacy", $$v)
                },
                expression: "form.privacy"
              }
            }),
            _vm._v(" "),
            _c("error-span", {
              attrs: { error: _vm.form.errors.get("privacy") }
            }),
            _vm._v(" "),
            _c("marketing-checkbox", {
              attrs: { id: "lead-marketing-checkbox", lang: _vm.lang },
              model: {
                value: _vm.form.marketing,
                callback: function($$v) {
                  _vm.$set(_vm.form, "marketing", $$v)
                },
                expression: "form.marketing"
              }
            }),
            _vm._v(" "),
            _c("marketing-agency-checkbox", {
              attrs: { id: "lead-marketing-agency-checkbox", lang: _vm.lang },
              model: {
                value: _vm.form.marketing_agency,
                callback: function($$v) {
                  _vm.$set(_vm.form, "marketing_agency", $$v)
                },
                expression: "form.marketing_agency"
              }
            })
          ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-check" },
        [
          _c("tooltip", { attrs: { text: _vm.langPrivacy.privacy_agency } }, [
            _c(
              "button",
              {
                staticClass: "btn btn-network mt-1",
                class: "btn-network-" + _vm.estate.network,
                on: {
                  click: function($event) {
                    return _vm.onSubmit()
                  }
                }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.trans("labels.send")) +
                    "\n                "
                )
              ]
            )
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }